import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LS } from 'src/app/helpers/localStorage.enum';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  API_SERVER: string = environment.baseApiUrl;

  constructor(
    private httpClient: HttpClient,
    private auth: AuthService
  ) { }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  findAll(params?: any): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient.get(this.API_SERVER + 'user', { params: Params }).pipe(
      map(this.extractData)
    )
  }

  findAllByGroup(params?: any): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }
    return this.httpClient.get(this.API_SERVER + 'user/all-by-group', { params: Params }).pipe(
      map(this.extractData)
    )
  }

  findAllUserLogins(): Observable<any> {
    return this.httpClient.get(this.API_SERVER + 'user-login').pipe(
      map(this.extractData)
    )
  }

  findOwn(): Observable<any> {
    return this.httpClient.get(this.API_SERVER + `user/profile`).pipe(
      map(this.extractData)
    )
  }

  findOne(id): Observable<any> {
    return this.httpClient.get(this.API_SERVER + `user/${id}`).pipe(
      map(this.extractData)
    )
  }

  create(data): Observable<any> {
    return this.httpClient.post(this.API_SERVER + 'user', data).pipe(
      map(this.extractData)
    )
  }

  update(id, data, isAdmin: boolean): Observable<any> {
    const route = isAdmin ? `user/${id}` : 'user/profile'
    return this.httpClient.put(this.API_SERVER + route, data).pipe(
      map(this.extractData)
    )
  }

  removeOrg(id, data): Observable<any> {
    return this.httpClient.put(this.API_SERVER + `user/remove_organisation/${id}`, data).pipe(
      map(this.extractData)
    )
  }

  remove(id): Observable<any> {
    return this.httpClient.delete(this.API_SERVER + `user/${id}`).pipe(
      map(this.extractData)
    )
  }

  restore(id): Observable<any> {
    return this.httpClient.delete(this.API_SERVER + `user/restore/${id}`).pipe(
      map(this.extractData)
    )
  }

  toggleFavAnnotation(annotation_id) {
    return this.httpClient.put(this.API_SERVER + `/user/toggle-favourite-annotation/${annotation_id}`, {}).pipe(
      map(this.extractData)
    )
  }

  /**
   * Updates user preference
   * @param userId User Id to change preference
   * @param field Preference field to change
   * @param value new value for the field
   */
  setPreference(userId: string, field: string, value: any) {
    return this.httpClient.put(this.API_SERVER + `user/preferences/${userId}`, { [field]: value }).pipe(map(this.extractData))
  }

  /**
   * Get user preference
   * @param userId User ID to retrieve preference from
   * @param field Field to retrieve
   */
  getPreference(userId: string): Observable<IUserPreference> {
    const res$: Subject<IUserPreference> = new Subject<IUserPreference>()

    // this.findOne(userId).pipe(take(1)).subscribe(user => {
    this.findOwn().pipe(take(1)).subscribe(user => {
      const { preferences } = user

      if (preferences) {
        res$.next(preferences)
      }
      else res$.next(null)
    })
    // }
    return res$
  }

  setNotification(id, data): Observable<any> {
    return this.httpClient.put(this.API_SERVER + `user/notifications/${id}`, data).pipe(
      map(this.extractData)
    )
  }

  findAssignee(): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + 'user/assignee')
  }
}
export interface IUserPreference {
  def_lang?: string
}

export function getCurrentUser(): {
  user_id: string
  token: string
  roles: string[]
  username: string
  permissions: any
  organisation: any
} {
  const currUserStr = localStorage.getItem(LS.currentUser)
    , currentUser = JSON.parse(currUserStr)

  return currentUser
}
